<template>
  <div class="bbr-exercises--search-canonical-exercise-input">
    <v-autocomplete
      v-model="canonicalExercise"
      :label="label"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :error-messages="errorMessages"
      :hide-details="!errorMessages || !errorMessages.length"
      :clearable="clearable"
      item-text="name"
      item-value="id"
      no-filter
      outlined
      flat
    />
  </div>
</template>

<script>
import CanonicalExercise from '@/models/CanonicalExercise'
import { debounce, isEmpty } from 'lodash'

export default {
  name: 'SearchCanonicalExercisesInput',

  props: {
    value: {
      type: [Number, Object],
    },
    defaultValue: {
      type: [Object, Array],
    },
    label: {
      type: String,
      default: 'Canonical Exercise',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: [Object, Array],
    },
  },

  data() {
    return {
      search: '',
      canonicalExercise: this.value,
      items: [],
      isLoading: false,
    }
  },

  created() {
    if (!isEmpty(this.defaultValue)) {
      this.setDefaultValue()
    }
  },

  methods: {
    searchCanonicalExercises: debounce(function() {
      this.isLoading = true

      this.fetchSearched()
        .then(({ data }) => {
          this.items = data
        })
        .finally(() => {
          this.isLoading = false
        })
    }, 250),

    async fetchSearched() {
      return CanonicalExercise.page(1)
        .where('search', this.search)
        .orderBy('name')
        .params({ limit: 100 })
        .get()
    },

    setDefaultValue() {
      this.canonicalExercise = this.value

      if (Array.isArray(this.defaultValue)) {
        this.items.push(...this.defaultValue)
      } else {
        this.items.push(this.defaultValue)
      }
    },
  },

  watch: {
    defaultValue() {
      this.setDefaultValue()
    },

    search(value) {
      if (value) {
        this.searchCanonicalExercises()
      }
    },

    canonicalExercise(value) {
      this.$emit('input', value)
    },

    value(value) {
      this.canonicalExercise = value
    },
  },
}
</script>
